/* ============
 * FileTypes State
 * ============
 *
 * The state of the file-types module.
 */
export const ALL = 'ALL';

export default ALL;



// WEBPACK FOOTER //
// ./src/store/modules/file-types/types.js